"use client";

import React from "react";
import Nav from "./Nav";
import Image from "next/image";
import Link from "next/link";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { useState, useEffect } from "react";

// Utils
import { userService } from "@/services/user.service";
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Context
import { useContextElement } from "@/context/Context";


export default function Header4() {
	console.log("HEADER4 LOADED - FIX VERSION");
	const [userData, setUserData] = useState([]);
	const [userState, setUserState] = useState(false);
	const [searchQuery, setSearchQuery] = useState("");
	const [isCategory, setIsCategory] = useState(false);
	const [settings, setSettings] = useState([]);
	const [bannerText, setBannerText] = useState("");

	// Folosim context-ul pentru coș
	const { cartProducts } = useContextElement();

	const router = useRouter();
	const pathname = usePathname();
	const searchParams = useSearchParams();

	const cartCount = cartProducts.reduce((sum, item) => sum + (item.quantity || 0), 0);

	useEffect(() => {
		let alive = true;

		const safe = (fn) => alive && fn();

		const fetchUserData = async () => {
			try {
				const u = userService.userValue;

				if (!u?.token) {
					safe(() => {
						setUserData([]);
						setUserState(false);
					});
					return;
				}

				const response = await fetchWrapper.get(`/api/users/getdata`);

				safe(() => {
					setUserData(response?.[0]?.userData ?? []);
					setUserState(true);
				});
			} catch (e) {
				safe(() => {
					setUserData([]);
					setUserState(false);
				});
			}
		};

		const fetchSiteSettings = async () => {
			try {
				const u = userService.userValue;

				if (!u?.token) return;

				const response = await fetchWrapper.get(`/api/admin/settings`);

				safe(() => {
					const list = response?.settings ?? [];
					setSettings(list);

					const bannerSetting = list.find((s) => s.name === "bannerText");
					if (bannerSetting?.value?.trim()) setBannerText(bannerSetting.value);
				});
			} catch (e) {
				// ignore
			}
		};

		fetchUserData();
		fetchSiteSettings();

		const sub = userService.user.subscribe(() => {
			fetchUserData();
			fetchSiteSettings();
		});

		return () => {
			alive = false;
			sub.unsubscribe();
		};
	}, []);


	useEffect(() => {
		async function checkIfCategory() {
			if (!pathname || pathname === "/") {
				setIsCategory(false);
				return;
			}

			const slugPath = pathname.replace(/^\//, "");

			if (!slugPath) {
				setIsCategory(false);
				return;
			}

			const reservedPaths = [
				"autentificare", "checkout", "contact", "cos-de-cumparaturi",
				"formular-retur", "inregistrare", "order-confirmation",
				"page-not-found", "placed-order", "politica-cookies",
				"politica-de-confidentialitate", "problem-order",
				"reduceri", "termeni-si-conditii", "toate-produsele", "wishlist"
			];

			const mainSlug = slugPath.split('/')[0];

			if (reservedPaths.includes(mainSlug)) {
				setIsCategory(false);
				return;
			}

			try {
				const response = await fetch(`/api/categories/${slugPath}`);

				if (response.ok) {
					const data = await response.json();
					setIsCategory(data.productsData ? true : false);
				} else {
					setIsCategory(false);
				}
			} catch (error) {
				setIsCategory(false);
			}
		}

		checkIfCategory();
	}, [pathname]);

	useEffect(() => {
		const q = searchParams.get("q");
		setSearchQuery(q || "");
	}, [searchParams]);

	const handleSearch = (e) => {
		e.preventDefault();

		if (!searchQuery.trim()) return;

		const sanitizedQuery = searchQuery.trim().slice(0, 100);
		// Căutare globală
		router.push(`/?q=${encodeURIComponent(sanitizedQuery)}`);
	};

	return (
		<>
			<div style={{ position: "sticky", top: 0, zIndex: 9999 }}>
			{/* Banner transport gratuit */}
			<div style={{
				background: "#000",
				color: "white",
				textAlign: "center",
				padding: "9px 16px",
				fontSize: "13px",
				fontWeight: 500,
				letterSpacing: "0.2px",
			}}>
				🚚 Transport gratuit pentru comenzi peste <strong>499 lei</strong>! Produsele voluminoase (scutere, tricicluri, generatoare etc.) nu beneficiază de transport gratuit.
			</div>

			{/* Banner informativ */}
			{bannerText && (
				<div className='info-banner-wrapper'>
					<style jsx>{`
						.info-banner-wrapper {
							background: linear-gradient(135deg, #007bff 0%, #2da4d0ff 100%);
							position: relative;
							overflow: hidden;
						}

						.info-banner-wrapper::before {
							content: "";
							position: absolute;
							top: 0;
							left: -100%;
							width: 100%;
							height: 100%;
							background: linear-gradient(
								90deg,
								transparent,
								rgba(255, 255, 255, 0.1),
								transparent
							);
							animation: shine 3s infinite;
						}

						@keyframes shine {
							0% {
								left: -100%;
							}
							100% {
								left: 100%;
							}
						}

						.info-banner {
							padding: 12px 20px;
							animation: slideDown 0.4s ease-out;
						}

						@keyframes slideDown {
							from {
								transform: translateY(-100%);
								opacity: 0;
							}
							to {
								transform: translateY(0);
								opacity: 1;
							}
						}

						.banner-container {
							max-width: 1400px;
							margin: 0 auto;
							display: flex;
							align-items: center;
							justify-content: center;
							position: relative;
							gap: 12px;
						}

						.banner-icon {
							background: rgba(255, 255, 255, 0.2);
							width: 32px;
							height: 32px;
							border-radius: 50%;
							display: flex;
							align-items: center;
							justify-content: center;
							flex-shrink: 0;
							backdrop-filter: blur(10px);
							box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
						}

						.banner-icon svg {
							width: 18px;
							height: 18px;
							color: white;
						}

						.banner-content {
							display: flex;
							align-items: center;
							gap: 8px;
						}

						.banner-text {
							color: white;
							font-size: 14px;
							font-weight: 500;
							letter-spacing: 0.3px;
							text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
							margin: 0;
							line-height: 1.4;
						}

						.close-button {
							position: absolute;
							right: 0;
							background: rgba(255, 255, 255, 0.15);
							border: none;
							width: 28px;
							height: 28px;
							border-radius: 50%;
							display: flex;
							align-items: center;
							justify-content: center;
							cursor: pointer;
							transition: all 0.2s ease;
							backdrop-filter: blur(10px);
						}

						.close-button:hover {
							background: rgba(255, 255, 255, 0.25);
							transform: scale(1.1);
						}

						.close-button svg {
							width: 14px;
							height: 14px;
							color: white;
						}

						@media (max-width: 768px) {
							.info-banner {
								padding: 10px 15px;
							}

							.banner-text {
								font-size: 13px;
							}

							.banner-icon {
								width: 28px;
								height: 28px;
							}

							.banner-icon svg {
								width: 16px;
								height: 16px;
							}

							.close-button {
								width: 24px;
								height: 24px;
							}
						}

						@media (max-width: 480px) {
							.banner-container {
								gap: 8px;
							}

							.banner-text {
								font-size: 12px;
							}
						}
					`}</style>
					<div className='info-banner'>
						<div className='banner-container'>
							<div className='banner-icon'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									viewBox='0 0 24 24'
									fill='none'
									stroke='currentColor'
									strokeWidth='2.5'
									strokeLinecap='round'
									strokeLinejoin='round'>
									<circle cx='12' cy='12' r='10' />
									<line x1='12' y1='16' x2='12' y2='12' />
									<line x1='12' y1='8' x2='12.01' y2='8' />
								</svg>
							</div>

							<div className='banner-content'>
								<p className='banner-text'>{bannerText}</p>
							</div>
						</div>
					</div>
				</div>
			)}

			<header id='header' className='header-default header-style-2'>
				<style jsx>{`
					.info-banner {
						background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
						color: white;
						padding: 10px 0;
						text-align: center;
						font-size: 14px;
						font-weight: 500;
						box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
						animation: slideDown 0.3s ease-out;
					}

					.banner-content {
						display: flex;
						align-items: center;
						justify-content: center;
						gap: 8px;
					}

					.icon-info:before {
						content: "ℹ️";
						font-style: normal;
						margin-right: 4px;
					}

					@keyframes slideDown {
						from {
							transform: translateY(-100%);
							opacity: 0;
						}
						to {
							transform: translateY(0);
							opacity: 1;
						}
					}

					@media (max-width: 768px) {
						.info-banner {
							font-size: 13px;
							padding: 8px 0;
						}

						.banner-content span {
							padding: 0 10px;
						}
					}

					.tf-search-mobile {
						padding: 8px 16px 12px;
						background: #fff;
						position: sticky;
						top: 0;
						z-index: 5;
					}

					.tf-search-mobile form {
						display: flex;
						align-items: center;
						gap: 0;
						background-color: #f0f2f5;
						border-radius: 12px;
						padding: 2px 4px;
						border: 1px solid transparent;
						transition: all 0.2s ease;
					}

					.tf-search-mobile form:focus-within {
						background-color: #fff;
						border-color: #0074d9;
						box-shadow: 0 4px 12px rgba(0, 116, 217, 0.1);
					}

					.tf-search-mobile input {
						flex: 1;
						height: 40px;
						border: none;
						background: transparent;
						padding: 0 12px;
						font-size: 14px;
						color: #333;
					}

					.tf-search-mobile input:focus {
						outline: none;
					}

					.tf-search-mobile button {
						width: 36px;
						height: 36px;
						border: none;
						border-radius: 10px;
						background-color: transparent;
						display: flex;
						align-items: center;
						justify-content: center;
						color: #666;
						transition: all 0.2s;
					}

					.tf-search-mobile button:hover {
						color: #0074d9;
					}

					/* Badge pentru coș */

					/* Badge pentru coș */
					.cart-badge-wrapper {
						position: relative;
						display: inline-block;
					}

					.cart-badge {
						position: absolute;
						top: -8px;
						right: -8px;
						background-color: #ff4444;
						color: white;
						border-radius: 50%;
						min-width: 20px;
						height: 20px;
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: 11px;
						font-weight: 600;
						padding: 0 5px;
						box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
						z-index: 1;
					}

					@media (max-width: 992px) {
						.tf-search-mobile {
							margin-bottom: 16px;
						}
					}
				`}</style>
				<div className='main-header line'>
					<div className='container-full px_15 lg-px_40'>
						{/* Prima linie - Menu + Logo + Icons */}
						<div className='row wrapper-header align-items-center'>
							<div className='col-xl-2 tf-md-hidden'>
								<div className='tf-cur'>
									<Link href={`/`} className='logo-header'>
										<Image
											alt='logo'
											className='logo'
											src='/images/logo/emagyl.png'
											width={273}
											height={22}
										/>
									</Link>
								</div>
							</div>

							{/* Mobile: Menu burger */}
							<div className='col-4 tf-lg-hidden'>
								<a href='#mobileMenu' data-bs-toggle='offcanvas' aria-controls='offcanvasLeft' className="text-dark">
									<i className="icon-list" style={{ fontSize: "24px" }} />
								</a>
							</div>

							{/* Mobile: Logo centrat */}
							<div className='col-4 tf-lg-hidden text-center'>
								<div className='tf-cur'>
									<Link href={`/`} className='logo-header only-mobile'>
										<Image
											alt='logo'
											className='logo'
											src='/images/logo/emagyl.png'
											width={136}
											height={21}
										/>
									</Link>
								</div>
							</div>

							{/* Desktop: Search bar */}
							<div className='col-xl-7 tf-md-hidden text-center'>
								<div className='tf-search-sticky nav-icon-text' style={{ width: "100%" }}>
									<form
										className='tf-mini-search-frm'
										onSubmit={handleSearch}
										style={{ display: "flex", alignItems: "center" }}>
										<fieldset className='tf-mini-search-frm' style={{ flexGrow: 1 }}>
											<input
												type='text'
												placeholder='Incepe o noua cautare'
												tabIndex='0'
												aria-required='true'
												required
												value={searchQuery}
												onChange={(e) => setSearchQuery(e.target.value)}
												style={{
													minHeight: "44px",
													width: "100%",
													padding: "10px 12px",
													fontSize: "16px",
												}}
											/>
										</fieldset>
									</form>
								</div>
							</div>

							{/* Icons - desktop full, mobile compressed */}
							<div className='col-xl-3 col-4'>
								<ul className='nav-icon d-flex justify-content-end align-items-center gap-20'>
									<li className='nav-cart tf-md-hidden'>
										<a
											href={userState ? "/contul-meu" : "/autentificare"}
											className='nav-icon-item'>
											<i className='icon icon-account' />{" "}
											<div className='nav-icon-text' style={{ marginLeft: 5 }}>
												{userState && userData ? (
													<>{userData.firstName + " " + userData.lastName}</>
												) : (
													<>Contul meu</>
												)}
											</div>
										</a>
									</li>

									<li className='nav-cart'>
										<Link href={`/wishlist`} className='nav-icon-item'>
											<i className='icon icon-heart' style={{ fontSize: "20px" }} />
											<div
												className='nav-icon-text tf-md-hidden'
												style={{ marginLeft: 5 }}>
												Favorite
											</div>
										</Link>
									</li>

									<li className='nav-cart'>
										<Link href='/cos-de-cumparaturi' className='nav-icon-item'>
											<div className='cart-badge-wrapper'>
												<i className='icon icon-bag' style={{ fontSize: "20px" }} />
												{cartCount > 0 && (
													<span className='cart-badge'>{cartCount}</span>
												)}
											</div>
											<div
												className='nav-icon-text tf-md-hidden'
												style={{ marginLeft: 5 }}>
												Cosul meu
											</div>
										</Link>
									</li>
								</ul>
							</div>
						</div>

						{/* A doua linie - Search bar DOAR pe mobile */}
						<div className='row tf-lg-hidden'>
							<div className='col-12'>
								<div className='tf-search-mobile'>
									<form onSubmit={handleSearch}>
										<input
											type='text'
											placeholder='Caută produse, branduri sau categorii'
											required
											value={searchQuery}
											onChange={(e) => setSearchQuery(e.target.value)}
										/>
										<button type='submit'>
											<svg
												xmlns='http://www.w3.org/2000/svg'
												width='18'
												height='18'
												viewBox='0 0 24 24'
												fill='none'
												stroke='currentColor'
												strokeWidth='2'
												strokeLinecap='round'
												strokeLinejoin='round'>
												<circle cx='11' cy='11' r='8'></circle>
												<path d='m21 21-4.35-4.35'></path>
											</svg>
										</button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Desktop navigation */}
				<div className='header-bottom line tf-md-hidden'>
					<div className='container-full px_15 lg-px_40'>
						<div className='wrapper-header d-flex justify-content-start align-items-start'>
							<nav className='box-navigation text-left'>
								<ul className='box-nav-ul d-flex align-items-center justify-content-start gap-30'>
									<Nav />
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</header>
			</div>
		</>
	);
}
